import React from "react";
import { Input, Button } from "reactstrap";
import styles from "./index.module.scss";

export interface HelpSearchProps {
    search: string;
    typeFilter: "all" | "PDF" | "Video"; // Updated to match Salesforce values
    onSearchChange: (search: string) => void;
    onTypeFilterChange: (type: "all" | "PDF" | "Video") => void; // Updated to match Salesforce values
}

export const HelpSearch: React.FC<HelpSearchProps> = ({
    search,
    typeFilter,
    onSearchChange,
    onTypeFilterChange,
}) => {
    return (
        <div className={styles.searchContainer}>
            <div className={styles.searchInput}>
                <Input
                    id="helpSearch"
                    placeholder="Search by title or description..."
                    value={search}
                    onChange={(e) => onSearchChange(e.target.value)}
                />
            </div>
            <div className={styles.typeFilter}>
                <div className={styles.selectWrapper}>
                    <Input
                        id="helpTypeFilter"
                        type="select"
                        value={typeFilter}
                        onChange={(e) => onTypeFilterChange(e.target.value as "all" | "PDF" | "Video")}
                    >
                        <option value="all">All</option>
                        <option value="PDF">PDF</option>
                        <option value="Video">Video</option>
                    </Input>
                    <div className={styles.dropdownIcon}></div>
                </div>
            </div>
            {(search !== "" || typeFilter !== "all") && (
                <div className={styles.clearButton}>
                    <Button
                        color="secondary"
                        onClick={() => {
                            onSearchChange("");
                            onTypeFilterChange("all");
                        }}
                    >
                        Clear
                    </Button>
                </div>
            )}
        </div>
    );
};

export default HelpSearch;
